import type { ContenuVitrine } from '@/features/marketing/i18n/contenu';
import { CONTENU_EN } from '@/features/marketing/i18n/contenu.en';
import { CONTENU_FR } from '@/features/marketing/i18n/contenu.fr';
import type { LangueVitrine } from '@/features/marketing/i18n/langues';

export type { ContenuVitrine } from '@/features/marketing/i18n/contenu';
export * from '@/features/marketing/i18n/langues';

/**
 * Le contenu d'une langue.
 *
 * Les deux dictionnaires portent le **même type** : le compilateur refuse qu'une langue oublie un
 * champ, sans qu'aucun test n'ait à le vérifier.
 */
export const contenuDe = (langue: LangueVitrine): ContenuVitrine =>
  langue === 'en' ? CONTENU_EN : CONTENU_FR;
